const reallocationQueryKeys = {
  all: [{ scope: 'reallocation' }] as const,
  lists: () => [{ ...reallocationQueryKeys.all[0], entity: 'list' }] as const,
  list: (context: { companyId?: string | null }) => [{ ...reallocationQueryKeys.lists()[0], ...context }] as const
}

export default reallocationQueryKeys
